import * as React from 'react'
import type { SelectOption } from '@ztechapps/webui.input'
import { NumberInput, RadioInput } from '@ztechapps/webui.input'
import { SaveCancelButtons } from '@ztechapps/webui.button'
import { Icon, ShowIf } from '@ztechapps/webui.util'
import { TaxTemplateSelect } from './TaxTemplateSelect'
import { Card, InputGroup } from 'react-bootstrap'

export const TaxEditContent = ({
  setNewValue,
  value,
  gross,
  onBlur,
  cancelNow,
  submitting,
}: {
  setNewValue?: (value: any) => void
  value?: Record<any, any>
  gross?: number
  onBlur?: () => Promise<any>
  cancelNow?: () => void
  submitting?: boolean
}) => {
  const [radioButtonValue, setRadioButtonValue] = React.useState<string>('amount')

  const [isAmount, setIsAmount] = React.useState<boolean>(true)

  const computeValue = (inputVal, isAmount) => {
    inputVal = !isNaN(inputVal) ? inputVal : 0
    if (isAmount) {
      setNewValue({
        amount: inputVal,
      })
    } else {
      setNewValue({
        amount: gross * (inputVal / 100),
        percent: inputVal,
      })
    }
  }

  return (
    <Card>
      <Card.Body>
        <ShowIf condition={radioButtonValue !== 'presets'}>
          <InputGroup>
            <NumberInput
              min={0}
              submitting={submitting}
              value={isAmount ? value?.amount : value?.percent}
              onChange={(e) => {
                const value = e?.target?.value
                computeValue(value, isAmount)
              }}
            />
            <InputGroup.Text>
              <Icon name={isAmount ? 'dollar' : 'percent'} />
            </InputGroup.Text>
          </InputGroup>
        </ShowIf>

        <ShowIf condition={radioButtonValue === 'presets'}>
          <TaxTemplateSelect
            isDisabled={submitting}
            onChange={(e: SelectOption) => {
              const value = (e?.percent ?? 0) * 100
              computeValue(value, false)
            }}
          />
        </ShowIf>

        <div className={'my-2'}>
          <RadioInput
            submitting={submitting}
            inline
            checked={radioButtonValue === 'amount'}
            name={'tax_amount'}
            label={'Amount'}
            onChange={() => {
              setRadioButtonValue('amount')
              setIsAmount(true)
            }}
          />

          <RadioInput
            submitting={submitting}
            inline
            checked={radioButtonValue === 'percent'}
            name={'tax_percent'}
            label={'Percent'}
            onChange={() => {
              setRadioButtonValue('percent')
              setIsAmount(false)
            }}
          />

          <RadioInput
            submitting={submitting}
            inline
            checked={radioButtonValue === 'presets'}
            name={'tax_presets'}
            label={'Presets'}
            onChange={() => {
              setRadioButtonValue('presets')
            }}
          />
        </div>

        <div className={'mt-3'}>
          <SaveCancelButtons onSave={onBlur} onCancel={cancelNow} isBusy={submitting} />
        </div>
      </Card.Body>
    </Card>
  )
}
